// Runtime production-host check. Preview deploys (elker-website-*.vercel.app) and
// localhost run the SAME build as production, so a build-time env check isn't
// enough, gate on the actual hostname. Used to keep preview/localhost traffic
// out of both GTM/GA4 and the first-party analytics collector.
//
// Matches the apex and any elker.com subdomain (www, nz, etc.); excludes
// *.vercel.app previews and localhost.
export const isProductionHost = (hostname) =>
  hostname === 'elker.com' || hostname.endsWith('.elker.com')

export const useIsProductionHost = () => {
  if (process.server) return false
  return isProductionHost(window.location.hostname)
}
